import axios from "axios"
import { createContext, ReactNode, useEffect, useState } from "react"

interface IOauthConfig {
  url: string
  clientId: string
  redirectUrl: string
  responseType: string
  tokenScope: string
}

interface IConfigContext {
  oAuth: IOauthConfig | null
  timerAlertIntervalInSec: number | null
  maxFileSizeMb: number | null
  offerEvaluationPoolTime: string | null
  productUrl: string | null
  slideUrl: string | null
  introspectUrl: string | null
  exchangeUrl: string | null
  interestBuborUrl: string | null
  interestBuborUrlText: string | null
}

interface ConfigProviderProps {
  children: ReactNode
}

const ConfigContext = createContext<IConfigContext | null>(null)

export const ConfigProvider = (props: ConfigProviderProps) => {
  const [context, setContext] = useState(null)

  useEffect(() => {
    ;(async () => {
      const response = await axios.get(`/app/config`, {
        responseType: "json",
      })
      setContext(response.data)
    })()
  }, [])

  return (
    context && (
      <ConfigContext.Provider value={context}>
        {props.children}
      </ConfigContext.Provider>
    )
  )
}

export default ConfigContext
